<template>
  <div>
    <b-modal id="modalEditSystemUsers" ref="modalEditSystemUsers" :title="$t('System user')" hide-footer  @shown="shown">
      <div v-if="editItem">
        <b-form-group label-align="right" :label="$t('Login')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.login" aria-describedby="inputFeedbackLogin" :state="editItem.login.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackLogin">
            {{ $t('Enter only english letters, numbers, at least 1 letter') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group v-if="!isEdit" label-align="right" :label="$t('Generated password')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" disabled  v-model="genPass"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Password')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="password" v-model="editItem.password"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Confirm password')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="password" v-model="confirmPassword"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('IPv4')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-input-group>
              <b-form-input style="text-align:right" type="text" v-model="editItem.ip4"/>
              <template v-slot:append>
                <b-form-input style="text-align:left;margin-left:5px;max-width:60px" type="text" v-model="editItem.mask4"/>
              </template>
          </b-input-group>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('IPv6')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-input-group>
              <b-form-input style="text-align:right" type="text" v-model="editItem.ip6"/>
              <template v-slot:append>
                <b-form-input style="text-align:left;margin-left:5px;max-width:60px" type="text" v-model="editItem.mask6"/>
              </template>
          </b-input-group>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('API Token')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-input-group size="sm">
            <b-form-input type="text" v-model="editItem.token"/>
              <template v-slot:append >
                <md-button class="md-raised md-dense" style="margin-top:0px" @click="editItem.token=generatePass(30)">{{ $t('Create') }}</md-button>
              </template>
            </b-input-group>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Is rest-api available')" label-cols="4" label-cols-xl="4" label-cols-md="4">
           <b-form-checkbox switch size="lg" v-model="editItem.is_rest_available" value="true" unchecked-value="false" />
        </b-form-group>
        <b-row align-h="center">
        <md-button class="md-raised md-dense" @click="ShowAddGroup">{{ $t('Add group') }}</md-button>
        </b-row>
        <b-row style="margin-top:1rem">

          <basic-table
            :items="systemUsersGroups"
            :fields="fieldsSystemUsersGroups"
            @ClickOnDeleteButton="DeleteSysGroup"
            isDelete="true"/>
        </b-row>

        <modal-ok-cancel @save="save" @cancel="() => {$refs.modalEditSystemUsers.hide()}" />
      </div>
    </b-modal>

    <b-modal ref="addGroup" hide-footer>

      <basic-table
        :items="allSystemUsersGroups"
        :fields="fieldsAllSystemUsersGroups"
        @RowSelected="SysGroupSelected"/>

        <modal-ok-cancel @save="AddSysGroup" @cancel="$bvModal.hide('addGroup')" size="md"/>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null,
    isEdit: null
  },
  data () {
    return {
      fieldsSystemUsersGroups: [
        { key: 'group_id', label: this.$i18n.t('ID'), sortable: true },
        { key: 'group_name', label: this.$i18n.t('Name'), sortable: true },
        { key: 'group_info', label: this.$i18n.t('Information'), sortable: true },
        { key: 'actions', label: this.$i18n.t('Actions') }
      ],
      fieldsAllSystemUsersGroups: [
        { key: 'group_id', label: this.$i18n.t('ID'), sortable: true },
        { key: 'group_name', label: this.$i18n.t('Name'), sortable: true },
        { key: 'group_info', label: this.$i18n.t('Information'), sortable: true }
      ],
      genPass: null,
      confirmPassword: null,
      sysGroupToAdd: null
    }
  },
  methods: {
    shown () {
      if (this.isEdit) {
        this.confirmPassword = JSON.parse(JSON.stringify(this.editItem.password))
      } else {
        this.genPass = this.generatePass()
        this.editItem.password = JSON.parse(JSON.stringify(this.genPass))
        this.confirmPassword = JSON.parse(JSON.stringify(this.genPass))
      }
    },
    async save () {
      if (!this.validation()) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field login'), 'Error')
        return
      }
      if (this.editItem.password !== this.confirmPassword) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Password doesn`t match'), 'Error')
        return
      }

      this.editItem.mask4 = Number(this.editItem.mask4)
      this.editItem.mask6 = Number(this.editItem.mask6)
      this.editItem.is_rest_available = String(this.editItem.is_rest_available) === 'true'
      let response = this.isEdit
        ? this.$store.dispatch('Users/UPDATE_SYSTEM_USER', this.editItem)
        : this.$store.dispatch('Users/CREATE_SYSTEM_USER', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Users/GET_SYSTEM_USERS')
          this.$refs.modalEditSystemUsers.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    generatePass (length = 10) {
      let Pass = ''
      var uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      var lowercase = 'abcdefghijklmnopqrstuvwxyz'
      var numbers = '0123456789'
      var all = uppercase + lowercase + numbers
      for (var index = 0; index < length; index++) {
        var character = Math.floor(Math.random() * all.length)
        Pass += all.substring(character, character + 1)
      }
      return Pass
    },
    validation () {
      if (this.editItem.login.length === 0) {
        return false
      }
      let strArray = this.editItem.login.split('')
      let goodChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@.,-+_/()'.split('')
      strArray = strArray.filter((value) => {
        return goodChars.includes(value)
      })
      return strArray.join('').length === this.editItem.login.length
    },
    ShowAddGroup () {
      if (!this.allSystemUsersGroups.length) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Not found available system groups'))
        return
      }
      this.sysGroupToAdd = null
      this.$refs.addGroup.show()
    },
    SysGroupSelected (sysGroup) {
      this.sysGroupToAdd = sysGroup
    },
    AddSysGroup () {
      if (this.sysGroupToAdd) {
        this.editItem.sys_groups.push(this.sysGroupToAdd.group_id)
        this.$refs.addGroup.hide()
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select system groups'))
      }
    },
    DeleteSysGroup (delSysGroup) {
      this.editItem.sys_groups = this.editItem.sys_groups.filter(item => { return !(delSysGroup.group_id === item) })
    }
  },
  computed: {
    systemUsersGroups () {
      return this.$store.getters['Users/SYSTEM_USERS_GROUPS'].filter(item => { return this.editItem.sys_groups.includes(item.group_id) })
    },
    allSystemUsersGroups () {
      return this.$store.getters['Users/SYSTEM_USERS_GROUPS'].filter(item => { return !this.editItem.sys_groups.includes(item.group_id) })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/systemUsers/editModal.vue